var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('video-player',{ref:"videoPlayer",staticClass:"video-css",attrs:{"options":_vm.videoOptions,"playsinline":true}}),_c('div',{staticClass:"play",on:{"click":function($event){return _vm.playVideo()}}},[_c('img',{attrs:{"src":require("../assets/img/play.png"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }